import {createRootContextHook} from 'common/util/react';

export const useThemes = createRootContextHook(`themes`);
